import { transform } from '@chakra-ui/react'
import {remCalc} from '_themeUtils'

const zoomImageModal = {
    ZoomImageModal: {
        baseStyle: () => ({
            zoomModalContent: {
                m: 0,
                maxW: '100vw',
                maxH: '100dvh',
                h: '100dvh',
                borderRadius: 0,
                bg: 'white',
            },
            zoomModalClose: {
                top: 'spacing.4',
                right: 'spacing.4',
                zIndex: 2,
            },
            zoomModalLayout: {
                w: '100%',
                h: '100%',
                gap: 0,
                alignItems: 'stretch',
            },
            ctaButtonsZoomWrapper: {
                alignItems: 'center',
                gap: {base: 'spacing.4', lg: 'spacing.8'},
                pt: {base: 'spacing.4', lg: 'spacing.8'},
                maxW: remCalc(20),
            },
            quickShareButton: {
                gap: 'spacing.2',
                textStyle: 'paragraphSm',
                textTransform: 'uppercase',
                letterSpacing: remCalc(1.5),
            },
            zoomModalCloseIcon: {
                pr: 'spacing.4',
            },
            zoomModalThumbnailsContainer: {
                w: {base: '100%', lg: remCalc(72)},
                position: 'absolute',
                zIndex: 2,
                top: {base: 'unset', lg: remCalc(16)},
                bottom: {base: remCalc(100), lg: 'unset'},
                left: {base: '50%', lg: remCalc(16)},
                transform: {base: 'translateX(-50%)', lg: 'unset'},
                flexDirection: 'column',
                overflowY: 'auto',
                alignItems: 'center',
            },
            zoomModalThumbnails: {
                w: {base: '80%', lg: '100%'},
                flexShrink: 0,
                display: 'flex',
                flexDirection: {base: 'row', lg: 'column'},
                gap: 'spacing.1',
                p: 'spacing.2',
                h: {base: '100px', lg: 'unset'},
                overflowX: {base: 'auto', lg: 'unset'},
            },
            zoomModalThumbnail: {
                position: 'relative',
                w: {base: 'auto', lg: '100%'},
                aspectRatio: '3/4',
                flexShrink: 0,
                cursor: 'pointer',
                transition: 'outline 0.1s ease',
                overflow: 'hidden',
                outline: '1px solid transparent',
                '&.active': {
                    outline: '1px solid currentColor',
                },
            },
            zoomModalThumbnailImageWrapper: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
            },
            zoomModalImageWrapper: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                overflowY: 'scroll',
            },
            zoomModalMain: {
                flex: 1,
                h: '100%',
                overflow: 'hidden',
            },
            zoomModalSlide: {
                position: 'relative',
                w: '100%',
                h: '100%',
            },
        }),
    },
}

export default zoomImageModal
